export default __webpack_public_path__ + "static/media/02-YT Music-Red.878556ea.png";